import React from 'react';
import styles from './About.module.scss';

export const About: React.FC = () => {
  return (
    <section id="about" className="chapter">
      <div className="container">
        <div className="card_area">
          <div className="card_title">
            <h1 className={styles.card_title_img}>会社概要</h1>
          </div>
          <div className={'card_content' + ' ' + styles.bg}>
            <div>
              <div className={styles.row}>
                <div className={styles.item}>会社名</div>
                <div className={styles.item}>
                  株式会社ミースチン (英名: Miistin Co., Ltd.)
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.item}>代表者</div>
                <div className={styles.item}>
                  代表取締役&nbsp;&nbsp;小田一貴
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.item}>設立日</div>
                <div className={styles.item}>2023年3月31日</div>
              </div>
              <div className={styles.row}>
                <div className={styles.item}>所在地</div>
                <div className={styles.item}>
                  〒220-0072
                  <br />
                  神奈川県横浜市西区浅間町1丁目4番3号
                  <br />
                  ウィザードビル402
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.item}>資本金</div>
                <div className={styles.item}>500,000円</div>
              </div>
              <div className={styles.row}>
                <div className={styles.item}>主な事業</div>
                <div className={styles.item}>
                  ソフトウェア設計・開発事業
                  <br />
                  スマートフォンアプリおよびゲーム、 Webアプリケーション・
                  <br />
                  バックエンドシステムの企画 / 開発 / 保守事業
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.item}>会社名の由来</div>
                <div className={styles.item}>
                  代表取締役の飼い猫に数多く付けられたあだ名のひとつから借用
                </div>
              </div>
              <div className={styles.row}>
                <div className={styles.item}>お問い合わせ</div>
                <div className={styles.item}>
                info@miistin.com
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
